
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/endorsements",
      function () {
        return require("private-next-pages/endorsements.tsx");
      }
    ]);
  